jQuery(($) => {

    if ($('.o-notification-bar')[0]) {
        if (localStorage.getItem('notificationBarState') != 'shown') {
            $('.o-notification-bar').show();

            $('.o-header').addClass('o-header--notification');
        } else {
            $('.o-notification-bar').remove();
        }

        $('.js-close-notification-bar').click(function () {
            localStorage.setItem('notificationBarState', 'shown');

            $('.o-notification-bar').remove();

            $('.o-header').removeClass('o-header--notification');

            $(this).remove();
        });

        if ($('.o-notification-bar__list')[0]) {
            $('.o-notification-bar__list').slick({
                autoplay: true,
                autoplaySpeed: 1500,
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                arrows: false,
                dots: false,
                pauseOnHover: true,
                swipe: true,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            arrows: false
                        }
                    }
                ]
            });
        }
    }
}); 